"use client";

import { usePathname } from "next/navigation";

// A malformed escape (`/%E0`) makes decodeURIComponent throw; show it raw instead.
export function safeDecode(text: string) {
  try {
    return decodeURIComponent(text);
  } catch {
    return text;
  }
}

// not-found pages get no params, so the missing URL is read in the browser.
export function NotFoundPath() {
  const pathname = usePathname() ?? "/";
  return (
    <p className="text-muted-foreground">
      <code className="rounded bg-zinc-800/80 px-1.5 py-0.5 text-sm text-slate-300 break-all">
        {safeDecode(pathname)}
      </code>{" "}
      doesn&apos;t exist or has moved.
    </p>
  );
}
